document.addEventListener('DOMContentLoaded', function () {
  // Find all DMOC JSON data elements on the page (for multiple product sections)
  const dmocDataElements = document.querySelectorAll(
    '[id^="product-variants-dmoc-"]'
  );

  dmocDataElements.forEach((dmocElement) => {
    const sectionId = dmocElement.id.split('product-variants-dmoc-')[1];
    const productVariantsDmocJSON = dmocElement.textContent;

    if (!productVariantsDmocJSON) return;

    try {
      const productVariantsDmoc = JSON.parse(productVariantsDmocJSON);

      if (!productVariantsDmoc?.length) {
        return;
      }

      const dmocItem = document.querySelector('[data-dmoc-item]');
      const dmocValue = dmocItem?.querySelector('[data-dmoc-value]');
      const mainContainer = document.querySelector(
        '[data-selected-variant-id].f-product-single'
      );

      if (!mainContainer || !dmocItem || !dmocValue) return;

      const updateDmoc = (variantId) => {
        const selectedVariant = productVariantsDmoc.find(
          (variant) => variant.id?.toString() === variantId?.toString()
        );

        if (selectedVariant?.dmoc) {
          const formattedPrice = formatMoney(
            selectedVariant.dmoc,
            window.FoxThemeSettings.money_format
          );
          dmocValue.textContent = formattedPrice;
          dmocItem.style.display = 'flex';
        } else {
          dmocValue.textContent = '';
          dmocItem.style.display = 'none';
        }
      };

      // Observer for variant changes (only runs after user changes variants)
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (
            mutation.type === 'attributes' &&
            mutation.attributeName === 'data-selected-variant-id'
          ) {
            updateDmoc(
              parseInt(mainContainer.getAttribute('data-selected-variant-id'))
            );
          }
        });
      });

      observer.observe(mainContainer, {
        attributes: true,
        attributeFilter: ['data-selected-variant-id'],
      });

      // No initial update - HTML already shows the correct initial variant value
    } catch (error) {
      console.error('Error parsing product variants DMOC JSON:', error);
    }
  });
});
